import styled from '@emotion/styled'
import login_bg from 'assets/images/login_bg.png'
import * as v from 'variables/styles'

export const LoginContainer = styled.div((props) => ({
  display: 'flex',
  justifyContent:'center',
  alignItems: 'center',
  flex: 1,
  background:'#fafafa',

  '.maintenanceContainer': {
    display: 'flex',
    width: '100%',
    justifyContent:'center',
    alignItems: 'center',
    height: '100%',
    borderRadius: '5px',
    padding: '15px',
    zIndex: 10,

    '.subContent': {
      width: '80%',
      display: 'flex',
      borderRadius: '5px',
      padding: '15px',
      background: '#FFF',
      flexDirection: 'column',

      '.textRow': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.2rem',

        time: {
          margin: '0px 5px'
        }
      }
    }
  }, 

  '.contBtn':{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    'button':{
      backgroundColor:`${v.ezOrange} !important`,
      width:'100%'
    }
  },

  form: {
    display: 'flex', 
    flexDirection: 'column'
  },

  '@media only screen and (min-width: 600px)': {
    /* For Tablet: */
    justifyContent: 'center',
    alignItems: 'center',
  },

  '@media only screen and (min-width: 769px)': {
    /* For Desktop: */
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
}))

export const BG = styled.div({
  position: 'absolute',
  width: '100%',
  height: '100%',
  backgroundImage: `url(${login_bg})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  zIndex: 0
})

export const SubCont = styled.div({
  display:'flex', 
  flexDirection:'column', 
  alignItems:'center',
  margin: '0px',
  width: '80vw', 
  zIndex: 1,

  '@media only screen and (min-width: 600px)': {
    /* For Tablet: */
    display:'flex', 
    flexDirection:'column', 
    alignItems:'center',
    margin: '0px',
    width: '60vw',
  },

  '@media only screen and (min-width: 769px)': {
    /* For Desktop: */
    display:'flex', 
    flexDirection:'column', 
    alignItems:'center',
    marginRight:'4rem',
    marginTop:'2rem',
    width: '30vw',
  }
})

export const FormContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: 'auto',
  width: '80%',
  padding: '10px',
  borderRadius: '5px',
  background: 'white',
  zIndex: 1,

  '@media only screen and (min-width: 600px)': {
    /* For Tablet: */
    width: '60%',
  },

  '@media only screen and (min-width: 769px)': {
    /* For Desktop: */
    width: '30%',
  }
})

